import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';

@Component({
    selector: 'db-info-tooltip',
    templateUrl: 'info-tooltip.component.html',
    styleUrls: ['info-tooltip.component.scss'],
    standalone: false
})
export class InfoTooltipComponent implements OnInit, AfterViewInit {

  @ViewChild('infoTooltip') infoTooltipRef: ElementRef;

  @Input() host: HTMLElement;
  @Input() position: 'top'|'top-right'|'bottom'|'left'|'right'|'custom'|'dropdown'|'bottom-right'|'bottom-left'|'bottom-right-from-left'|'bottom-right-header'|'bottom-right-header-mobile'|'bottom-right-header-tools-mobile';
  @Input() delay: number;
  @Input() infoTooltipHeader: string;
  @Input() dbInfoTooltipClass: string;
  @Input() dbInfoTooltipCustomClass?: string;
  @Input() infoTooltipBody: any;
  @Input() infoTooltipMoreInfo: string;
  @Input() infoTooltipMoreInfoLink?: string;
  @Input() infoTooltipMoreInfoLinkText?: string;
  @Input() premiumUpgrade: boolean;
  @Output() cancelHideEvent = new EventEmitter<any>();

  public infoTooltipStyle: any;
  public toggled: boolean;
  public isMobile: boolean;


  private top: any;
  private left: any;

  constructor(private $element: ElementRef) {
    this.infoTooltipStyle = {};
  }

  ngOnInit() {
    if (window.innerWidth < 991) {
      this.isMobile = true;
    }
  }
  ngAfterViewInit() {
    if (this.$element.nativeElement.querySelector('.callLiveChat')) {
      this.$element.nativeElement.querySelector('.callLiveChat').addEventListener('click', () => {

        window['Smooch']?.open();
      });
    }

    const hostBoundingBox: ClientRect = this.host.getBoundingClientRect();
    const infoTooltipBoundingBox: ClientRect = this.infoTooltipRef.nativeElement.getBoundingClientRect();
    switch (this.position) {
      case 'top':
        this.top = hostBoundingBox.top - infoTooltipBoundingBox.height;
        this.left = hostBoundingBox.left + hostBoundingBox.width / 2 - infoTooltipBoundingBox.width / 2;
        break;

      case 'top-right':
        this.top = hostBoundingBox.top - infoTooltipBoundingBox.height;
        if (hostBoundingBox.right + 385 > window.innerWidth) {
          this.left = hostBoundingBox.right - 365;
        }
        else {
          this.left = hostBoundingBox.right - 21;
        }
        break;

      case 'bottom':
        this.top = hostBoundingBox.bottom;
        this.left = hostBoundingBox.left + hostBoundingBox.width / 2 - infoTooltipBoundingBox.width / 2;
        if ((this.left + 450) > window.innerWidth) {
          this.left = hostBoundingBox.right - 450 - hostBoundingBox.width;
        }
        break;

      case 'bottom-right':
        this.top = hostBoundingBox.bottom;
        const width = this.dbInfoTooltipCustomClass && this.dbInfoTooltipCustomClass === 'b-add-website-manual-tooltip' ? 274 : 470;
        if (hostBoundingBox.right + width > window.innerWidth) {
          this.left = hostBoundingBox.right - width - hostBoundingBox.width;
        }
        else {
          this.left = hostBoundingBox.right - 31;
        }
        break;

      case 'bottom-left':
        this.top = hostBoundingBox.bottom;
        this.left = hostBoundingBox.left + hostBoundingBox.width + 10 - infoTooltipBoundingBox.width;
        break;

      case 'bottom-right-from-left':
        this.top = hostBoundingBox.bottom;
        if (hostBoundingBox.right > window.innerWidth) {
          this.left = hostBoundingBox.right - hostBoundingBox.width;
        }
        else {
          this.left = hostBoundingBox.right - hostBoundingBox.width - 10;
        }
        break;

      case 'left':
        this.top = hostBoundingBox.top + hostBoundingBox.height / 2 - infoTooltipBoundingBox.height / 2;
        this.left = hostBoundingBox.left - infoTooltipBoundingBox.width;
        break;

      case 'right':
        this.top = hostBoundingBox.top + hostBoundingBox.height / 2 - infoTooltipBoundingBox.height / 2;
        if (hostBoundingBox.right + 450 > window.innerWidth) {
          this.left = hostBoundingBox.right - 450 - hostBoundingBox.width;
        }
        else {
          this.left = hostBoundingBox.right;
        }
        break;

      case 'custom':
        this.top = hostBoundingBox.top;
        this.left = hostBoundingBox.left;
        break;

      case 'dropdown':
        this.top = hostBoundingBox.bottom - 9;
        this.left = hostBoundingBox.left + hostBoundingBox.width  - infoTooltipBoundingBox.width;
        break;


      case 'bottom-right-header':
        this.top = hostBoundingBox.bottom - 10;
        this.left = hostBoundingBox.right - 16 - hostBoundingBox.width;
        break;

      case 'bottom-right-header-mobile':
        this.top = hostBoundingBox.bottom - 10;
        this.left = hostBoundingBox.right - 110 - hostBoundingBox.width;
        break;

      case 'bottom-right-header-tools-mobile':
        this.top = hostBoundingBox.bottom - 10;
        this.left = hostBoundingBox.right - 103 - hostBoundingBox.width;
        break;

    }

    setTimeout((): void => {
      this.infoTooltipStyle = {
        top: this.top + 'px',
        left: this.left + 'px'
      };
    }, this.delay || 0);
  }

  public onMouseEnter(): void {
    this.cancelHideEvent.emit('show');
  }

  public onMouseLeave(): void {
    if ( !this.dbInfoTooltipCustomClass || (this.dbInfoTooltipCustomClass &&  this.dbInfoTooltipCustomClass !== 'db-main-header' )) {
      this.cancelHideEvent.emit('hide');
    }
  }

  @HostListener('mouseleave', ['$event']) mouseleave($event: any) {
    if ( !!$event.toElement) {
      this.cancelHideEvent.emit('hide');
    }
}

  @HostListener('document:click', ['$event']) onDocumentClick($event: any) {
      if (!this.toggled && this.host.contains($event.target)) {
        this.toggled = true;
        $event.stopImmediatePropagation();
      }
      else {
        this.toggled = false;
        this.cancelHideEvent.emit('hide');
      }
  }

}
